module.exports = __webpack_public_path__ + "img/percent-water-tool.0effb0c1.png";